module.exports = __webpack_public_path__ + "img/rooster-text.2876a0d9.webp";